// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","ant-form":"App_ant-form__3hfZU","ant-form-item":"App_ant-form-item__ooFdT"};